import _ from 'lodash'
import { PropsWithChildren, FC } from 'react'
import { useSelector } from 'react-redux'
import { DownloadOutlined } from '@ant-design/icons'
import { salesOrder_salesOrder_shipments_items as SalesOrderShipmentsItemType } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrder'
import { startSalesOrderInspectionZipDownload } from '@Orders/OrderDetailsPage/OrderDetailHeaderAndFooter/SalesOrderDownloadMessage'
import { selectFlags } from '@Orders/OrderDetailsPage/selectors'
import { BUTTON_MARGIN } from '@Orders/buttons/DownloadOrderConfirmationButton'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Tooltip from '~/core/Tooltip'

type PropType = {
    id: string
    shipments?: SalesOrderShipmentsItemType[]
    placement: string
}

export const InspectionReportDataBtn: FC<
    PropsWithChildren<PropType>
> = props => {
    const { id, shipments, placement } = props
    const { isTransparencyImprovementEnabled } = useSelector(selectFlags)

    const inspectionDownloadAvailable =
        Boolean(shipments?.length) &&
        shipments?.some(shipment => {
            return (
                shipment.shipmentLines?.items &&
                shipment.shipmentLines.items.length > 0 &&
                shipment.shipmentLines.items.some(shipmentLine => {
                    const inspectionDocuments = _.compact(
                        shipmentLine.inspectionDocuments,
                    )

                    return (
                        shipmentLine.woAvailableToShow &&
                        inspectionDocuments &&
                        inspectionDocuments.length > 0
                    )
                })
            )
        })

    const onClickDownloadInspectionReport = () => {
        startSalesOrderInspectionZipDownload({
            id,
        })
    }

    return (
        <Tooltip
            title={
                inspectionDownloadAvailable
                    ? null
                    : 'Inspection report not available'
            }
        >
            <Box>
                <Button
                    onClick={onClickDownloadInspectionReport}
                    name="download-inspection-report"
                    placement={placement}
                    style={{
                        ...BUTTON_MARGIN,
                        pointerEvents: inspectionDownloadAvailable
                            ? 'auto'
                            : 'none',
                    }}
                    data-test-target="download-inspection-files"
                    disabled={!inspectionDownloadAvailable}
                >
                    <DownloadOutlined />
                    {isTransparencyImprovementEnabled
                        ? 'All quality documents'
                        : 'Inspection report data'}
                </Button>
            </Box>
        </Tooltip>
    )
}
